import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import OptimizedImage from "@/components/OptimizedImage";

/**
 * Static hero component - renders immediately without animations
 * Loads faster for LCP optimization
 */
const HeroStatic = () => {
  const navigate = useNavigate();
  
  return (
    <section className="relative w-full nav-safe-pt pb-4 md:pb-6">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column - Content */}
          <div className="space-y-6">
            <div className="inline-block mb-2 px-4 py-2 bg-gray-800 text-white rounded-full text-sm font-bold shadow-sm">
              Homeownership shouldn't<br className="sm:hidden" />{" "}
              <span className="whitespace-nowrap sm:whitespace-normal">feel like guesswork.</span>
            </div>
            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              Feel in{" "}
              <span className="relative inline-block">
                <span className="relative z-10">control</span>
                <span className="absolute bottom-1 left-0 w-full h-2 sm:h-3 bg-[#60a5fa] -z-0 rounded-full"></span>
              </span>{" "}
              of your home<span style={{ color: '#62e28d' }}>.</span>
            </h1>
            
            <p className="text-lg md:text-xl text-on-gradient mt-4">
              Unlock a free membership that delivers personalized plans, access to our text concierge, and guidance for every task, season, appliance, and system in your home.
            </p>
            
            <div className="pt-4">
              <a href="https://app.housebeat.com/welcome" target="_blank" rel="noopener noreferrer">
                <Button 
                  size="lg"
                  className="min-h-[44px] px-8 py-3 text-base font-bold"
                >
                  Get Started
                </Button>
              </a>
              <p className="text-sm text-on-gradient mt-3">
                Available for FREE to all homeowners in Ontario, Manitoba, and Alberta.
              </p>
            </div>
          </div>
          
          {/* Right Column - Image */}
          <div className="relative w-full h-[400px] sm:h-[500px] lg:h-[600px] rounded-2xl overflow-hidden shadow-2xl">
            <OptimizedImage 
              src="/hero_homepage.jpg"
              alt="Family with young children standing in front of their home"
              className="w-full h-full object-cover"
              width={1200}
              height={800}
              context="hero"
              quality={60}
              fetchPriority="high"
              noPlaceholder={true}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroStatic;
